import React from 'react';
import { useNavigate } from 'react-router-dom';

const COURSES = [
  {
    code: 'MCD524',
    title: 'Análisis Topológico de Datos para Mercados Financieros',
    institution: 'INTEC',
    description: 'Topología algebraica aplicada a series de tiempo financieras: homología persistente, diagramas de persistencia, y estimación del exponente de Hurst via TDA.',
    path: '/classes/tda-ml',
    tags: ['TDA', 'Finanzas', 'Machine Learning'],
  },
  {
    code: 'ML-PY',
    title: 'Machine Learning con Python',
    institution: 'Cesar Garcia',
    description: 'Desde los fundamentos de Python hasta sistemas de IA con agentes. Deep learning moderno: tensores, backpropagation, CNNs, Transformers y agentes.',
    path: '/classes/python-ml',
    tags: ['Python', 'Deep Learning', 'PyTorch', 'Agentes IA'],
  },
];

export default function ClassesIndex() {
  const navigate = useNavigate();

  return (
    <div>
      <h1 style={{ fontSize: '1.75rem', fontWeight: 700, marginBottom: '0.4rem' }}>Clases</h1>
      <p style={{ color: 'var(--text-muted)', marginBottom: '2rem' }}>
        Materiales de cursos disponibles para estudiantes.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1.25rem' }}>
        {COURSES.map((course) => (
          <div
            key={course.code}
            onClick={() => navigate(course.path)}
            style={{
              background: 'var(--bg-card)',
              border: '1px solid var(--border)',
              borderRadius: 'var(--radius)',
              padding: '1.5rem',
              cursor: 'pointer',
              transition: 'border-color 0.15s, background 0.15s',
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.background = 'var(--bg-hover)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.background = 'var(--bg-card)'; }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.75rem' }}>
              <span style={{
                background: 'var(--accent-dim)',
                color: 'var(--accent)',
                fontSize: '0.75rem',
                fontWeight: 700,
                padding: '0.2rem 0.6rem',
                borderRadius: 6,
                letterSpacing: '0.04em',
              }}>
                {course.code}
              </span>
              <span style={{ color: 'var(--text-muted)', fontSize: '0.8rem' }}>{course.institution}</span>
            </div>

            <h2 style={{ fontSize: '1rem', fontWeight: 600, lineHeight: 1.4, marginBottom: '0.6rem' }}>
              {course.title}
            </h2>

            <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', lineHeight: 1.5, marginBottom: '1rem' }}>
              {course.description}
            </p>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
              {course.tags.map(tag => (
                <span key={tag} style={{
                  background: 'var(--bg-hover)',
                  color: 'var(--text-muted)',
                  fontSize: '0.75rem',
                  padding: '0.15rem 0.5rem',
                  borderRadius: 4,
                  border: '1px solid var(--border)',
                }}>
                  {tag}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
